import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon } from 'lucide-react';
export function PageHeader({
  title,
  right
}: {
  title: string;
  right?: React.ReactNode;
}) {
  const nav = useNavigate();
  return <div className="bg-white px-2 h-12 flex items-center justify-between border-b border-slate-100 sticky top-0 z-30" data-id="element-70">
      <button onClick={() => nav(-1)} className="p-2" aria-label="返回" data-id="element-71">
        <ChevronLeftIcon size={22} className="text-slate-700" data-id="element-72" />
      </button>
      <div className="font-bold text-slate-800 text-base" data-id="element-73">{title}</div>
      <div className="w-10 flex justify-end pr-2" data-id="element-74">{right}</div>
    </div>;
}